RivalIQ.apps.AdsInsights.module('utils', function (utils, App, Backbone, Marionette, $, _, s) {

    'use strict';

    const breadcrumbLevels = [
        RivalIQ.enums.facebookAdObjectTypes.ACCOUNT,
        RivalIQ.enums.facebookAdObjectTypes.CAMPAIGN,
        RivalIQ.enums.facebookAdObjectTypes.ADSET,
        RivalIQ.enums.facebookAdObjectTypes.AD
    ];

    const MAX_FILE_PART_LENGTH = 25;


    utils.adObjectCurationPath = function (curation, adObjectId, adObjectType) {
        return curation.getPath({
            instanceId: undefined,
            widgetId: undefined,
            adAccountId: curation.getProp('adAccountId'),
            adObjectId: adObjectId,
            limit: undefined,
            exploreLevel: utils.childExploreLevel(adObjectType)
        });
    };

    utils.calculateBreadcrumbsForAdObject = function (curation, adObject, options) {

        options = options || {};
        adObject = adObject || {};

        return _.reduce(breadcrumbLevels, function (memo, adObjectType) {
            const adObjectId = adObject[`${adObjectType}_id`];

            if (adObjectId) {
                const breadcrumbName = (adObjectId === adObject.adAccountId && !options.showAccountName ? 'Entire Account' : adObject[`${adObjectType}_name`]);

                memo.push({
                    breadcrumbName: breadcrumbName,
                    adObjectName: adObject[`${adObjectType}_name`],
                    href: (curation ? utils.adObjectCurationPath(curation, adObjectId, adObjectType) : null)
                });
            }

            return memo;
        }, []);
    };

    utils.handleLoadDataError = function (error, loadingView, dashboardModel) {
        if (utils.is404Error(error)) {
            loadingView.clearMessage();
            loadingView.$el.css('height', 'auto');
            loadingView.$el.addClass('widget-error-no-secondary-nav');
            loadingView.$el.html(Marionette.TemplateCache.get('#adInsightsObjectNotFoundTemplate')());
        } else if (utils.isRateLimitError(error)) {
            loadingView.clearMessage();
            loadingView.$el.css('height', 'auto');
            loadingView.$el.addClass('widget-error-no-secondary-nav');
            loadingView.$el.html(Marionette.TemplateCache.get('#adInsightsRateLimitExceededErrorTemplate')());
        } else {
            loadingView.$el.css('height', 'auto');
            loadingView.$el.addClass('widget-error');
            loadingView.$el.html(Marionette.TemplateCache.get('#widgetErrorView')());
        }

        if (dashboardModel.isExporting()) {
            RivalIQ.export.failExport(_.get(error, ['responseJSON', 'error', 'message'], error));
        }
    };

    utils.is404Error = function (error) {
        return (_.get(error, 'status') === 404 || _.get(error, ['responseJSON', 'error', 'statusCode']) === 404);
    };

    utils.isRateLimitError = function (error) {
        return _.get(error, 'errorName') === 'ExceededRateLimitError';
    };

    utils.getExportFilename = function (props, adObject, widgetTitle) {

        let title = adObject.account_name.substring(0, MAX_FILE_PART_LENGTH);

        if (props.adObjectId && props.adObjectId !== props.adAccountId) {
            const adObjectName = adObject[`${adObject.adObjectType}_name`];
            if (adObjectName) {
                title += `_${adObjectName.substring(0, MAX_FILE_PART_LENGTH)}`;
            }
        }

        if (widgetTitle) {
            title += `_${widgetTitle}`;
        }

        return RivalIQ.export.filename.base({
            title: title
        });
    };

    utils.getFiltersDescription = function (props, adLabels) {
        let defaultString = null;
        // NOTE we do the below dance so that the filters are displayed in the
        // order they appear on the page
        let applicableFilterProps = [];
        if (props.adAccountId === props.adObjectId) {
            applicableFilterProps = applicableFilterProps.concat([
                'campaignDeliveryStatus',
                'campaignObjective'
            ]);
            defaultString = 'All Campaigns';
        }

        applicableFilterProps.push('boostedPostFilter');

        if (props.adAccountId === props.adObjectId) {
            applicableFilterProps.push('campaignAdLabel');
        }

        return _.reduce(applicableFilterProps, function (memo, filter) {
            const filterValue = props[filter];
            if (filterValue) {
                if (memo) {
                    memo += ', ';
                } else {
                    memo = '';
                }

                switch (filter) {

                    case 'boostedPostFilter':
                        if (filterValue !== RivalIQ.enums.facebookAdBoostedPostFilters.INCLUDE_ALL.id) {
                            memo += _.find(RivalIQ.enums.facebookAdBoostedPostFilters, {
                                id: filterValue
                            }).name;
                        }
                        break;

                    case 'campaignObjective':
                        memo += _.map(filterValue.split(','), value => {
                            return _.find(RivalIQ.enums.facebookAdCampaignObjectives, {
                                id: value
                            }).name;
                        }).join(', ');
                        break;

                    case 'campaignDeliveryStatus':
                        memo += _.map(filterValue.split(','), value => {
                            return _.find(RivalIQ.enums.facebookAdDeliveryStatuses, {
                                id: value
                            }).name;
                        }).join(', ');
                        break;

                    case 'campaignAdLabel': {
                        const labels = _.map(filterValue.split(','), value => {
                            return _.get(_.find(adLabels, {
                                id: value.toString()
                            }), ['name'], value);
                        }).join(', ');

                        memo += `Label: ${labels}`;
                        break;
                    }

                    case 'adSetDeliveryStatus':
                        memo += _.map(filterValue.split(','), value => {
                            return _.find(RivalIQ.enums.facebookAdSetDeliveryStatuses, {
                                id: value
                            }).name;
                        }).join(', ');
                        break;

                    default:
                        memo += filterValue;
                }
            }

            return memo;
        }, null) || defaultString;
    };

    utils.breadcrumbString = function (adObject) {
        const breadcrumb = utils.calculateBreadcrumbsForAdObject(null, adObject, {
            showAccountName: true
        });
        return _.map(breadcrumb, function (breadcrumb) {
            return RivalIQ.utils.emoji.emojify(_.escape(s.prune(breadcrumb.breadcrumbName, 60)));
        })
            .join(', ');
    };

    utils.exportSubtitle = function () {
        const me = this;

        if (!me.isFocus()) {
            return;
        }

        let timePeriod = me.getProp('timePeriod');
        if (me.getProp('timePeriodType')) {
            timePeriod = RivalIQ.state.timePeriods.getByType(me.getProp('timePeriodType'));
        }

        return [
            utils.breadcrumbString(me.curation.adObject),
            RivalIQ.utils.timePeriod.getTimePeriodDisplayString(timePeriod)
        ].join('; ');
    };

    utils.constructAdObjectMetric = function (props) {
        return _.defaults({
            source: RivalIQ.enums.sources.FACEBOOK_ADS,
            channel: 'facebook',
            dimensions: ['timeAnalysisMode', 'adObjectId', 'channel'],
            timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
            property: 'adObject',
            limit: 1,
            lowSpendFilter: 0,
            orderBy: undefined,
            breakdownName: undefined,
            childObjectType: undefined
        }, props);
    };

    // We always end up loading impressions with adObject too, so load that as well. The server
    // can be more efficient if we ask for adObject and impressions at the same time.
    utils.fetchAdObject = function (props) {
        const baseMetric = {
            source: RivalIQ.enums.sources.FACEBOOK_ADS,
            channel: 'facebook',
            dimensions: ['timeAnalysisMode', 'adObjectId', 'channel'],
            timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
            property: 'adObject',
            limit: 1,
            orderBy: undefined,
            breakdownName: undefined,
            childObjectType: undefined
        };

        const adObjectMetric = _.defaults({
            property: 'adObject',
            lowSpendFilter: 0
        }, baseMetric, props);

        const adImpressionsMetric = _.defaults({
            property: 'impressions'
        }, baseMetric, props);

        const deferred = new $.Deferred();
        let startedBuffering = false;
        if (!RivalIQ.data.CacheLayer.isBuffering()) {
            startedBuffering = true;
            RivalIQ.data.CacheLayer.startBuffering();
        }

        const metricsCollection = new RivalIQ.collections.MetricDefinitions([adObjectMetric, adImpressionsMetric]);
        metricsCollection.fetch()
            .then(function (result) {
                deferred.resolve(result.at(0).getValue());
            });

        if (startedBuffering) {
            RivalIQ.data.CacheLayer.stopBuffering();
            RivalIQ.data.CacheLayer.flush();
        }

        return deferred;
    };

    utils.validCurationOptions = [
        'adObjectId',
        'adAccountId',
        'exploreLevel',
        'lowSpendFilter',
        'boostedPostFilter',
        'campaignObjective',
        'campaignAdLabel',
        'campaignDeliveryStatus',
        'adsetDeliveryStatus'
    ];
}, window.s);
